export enum CONTENT_TYPES {
  NOTICE = 'NOTICE',
  MAINTANCE = 'MAINTANCE',
}
